import { useSelector } from "react-redux"
import PageContainer from "../../components/PageContainer"
import PageTitle from "../../components/PageTitle"
import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CheckoutPage = () => {
    const [params] = useSearchParams();
    const total = params.get('total');
    const { t } = useTranslation();
    const { data } = useSelector(state => state.cart);
    const navigate = useNavigate();
    useEffect(() => {
        if (data.length === 0) navigate("/shop")
    }, [data])

    const goToFinal = () => {
        navigate("/confirm-order-request", { state: { checkFrom: true } })
    }
    return (
        <PageContainer items="center">
            <PageTitle title="Checkout" backLink="/cart" />
            <p>{t("Cart.CheckoutPage.confirmCopy")}</p>
            <div className="w-full border rounded-xl flex flex-col gap-2 p-4 text-sm md:w-[600px]">
                {
                    data && data.length > 0 && data.map((element, index) => {
                        return <div key={index} className="flex justify-between">
                            <div className="flex gap-4">
                                <div className="w-6 h-6 overflow-hidden rounded"><img src={element.coverImageUrl} alt="product image" className="h-full w-full object-cover" /></div>
                                <div>N.{element.quantity} {element.title}, {t('Cart.CheckoutPage.size')}: {element.size}</div>
                            </div>
                            <div>
                                {(element.price * element.quantity).toFixed(2)} CHF
                            </div>
                        </div>
                    })
                }
                <div className="w-full flex justify-between font-bold">
                    <div>{t('Cart.CheckoutPage.total')}:</div>
                    <div>CHF {total}</div>
                </div>
            </div>
            {/* Buttons */}
            <div className="w-full mt-8 flex justify-center gap-2">
                <Link to="/cart"><button className="border-2 rounded-xl py-2 px-4 border-[#225424]">{t('Cart.CheckoutPage.backToCart')}</button></Link>
                {data && data.length > 0 && <button className="border-2 rounded-xl py-2 px-4 bg-[#225424] text-white" onClick={goToFinal}>{t('Cart.CheckoutPage.confirmCheckout')}</button>}
            </div>
        </PageContainer>
    )
}

export default CheckoutPage